export class ArrayUtils {
    static orderBy(value1: any, value2: any, desc = false): number {
        if (typeof value1 === "string" && typeof value2 === "string") {
            value1 = value1.toLowerCase();
            value2 = value2.toLowerCase();
        }

        if (!value1 || !value2) {
            return !desc ? 1 : -1;
        }
        if (value1 > value2) {
            return !desc ? 1 : -1;
        }
        if (value1 < value2) {
            return !desc ? -1 : 1;
        }
        return 0;
    }
}
